// extracted by mini-css-extract-plugin
module.exports = {"button":"ECouponProductPurchaseButton_button__CYeyK"};